<template>
  <div class="select-wrapper">
    <p
      class="select-wrapper__label"
      v-html="dataList.label"
    />
    <div
      :ref="dataList.id"
      class="select"
      :class="{ 'select--open': opened }"
      @click="toggleSelect"
    >
      <div
        class="select__trigger"
        :class="{ active: optionChoosed }"
      >
        <span>{{ placeholder }}</span>
        <div class="arrow" />
      </div>
      <div class="select__options">
        <template v-for="option in dataList.options">
          <span
            v-if="option.featureToggle === undefined || toggle[option.featureToggle]"
            :key="option.name"
            class="select__option"
            :data-value="option.name"
            @click="selectValue(option)"
          >
            {{ option.text }}
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MicrobiologyReportGenerator',
  props: {
    dataList: {
      required: true,
      type: Object,
    },
    preSelected: {
      type: String,
      default: '',
    },
  },
  data: () => {
    return {
      opened: false,
      placeholder: '',
      optionChoosed: false,
    }
  },
  computed: {
    ...mapGetters(['toggle']),
  },
  mounted() {
    this.placeholder = this.dataList.placeholder
    document.addEventListener('click', evt => this.getClickOutside(evt))

    if (this.preSelected) {
      const option = this.dataList.options.find(item => item.name === this.preSelected)
      if (
        option &&
        (option.featureToggle === undefined || this.toggle[option.featureToggle])
      ) {
        this.selectValue(option)
      }
    }
  },
  methods: {
    toggleSelect() {
      this.opened = !this.opened
    },
    selectValue(data) {
      this.placeholder = data.text
      this.optionChoosed = true
      this.$emit('valueSelected', data)
    },
    getClickOutside(evt) {
      const myElement = this.$refs[this.dataList.id]
      let targetElement = evt.target

      do {
        if (targetElement === myElement) return

        targetElement = targetElement.parentNode
      } while (targetElement)

      this.opened = false
    },
  },
}
</script>

<style lang="scss" scoped>
.select-wrapper {
  position: relative;
  user-select: none;
  width: 100%;

  &__label {
    font-size: 15px;
    margin-bottom: 24px;
  }
}

.select {
  position: relative;
  display: flex;
  flex-direction: column;
  font-size: 14px;

  &:hover {
    cursor: pointer;
  }

  &--open {
    .select__options {
      opacity: 1;
      visibility: visible;
      pointer-events: all;
    }
    .select__trigger {
      border-radius: 3px 3px 0 0;
    }

    .arrow:after {
      transform: rotateX(180deg);
      border-width: 5px 5px 0 5px;
    }
  }

  &__trigger {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 22px;
    color: #7a7a7a;
    height: 36px;
    line-height: 36px;
    background: #ffffff;
    cursor: pointer;
    border-radius: 3px;
    overflow: hidden;

    &.active {
      color: #303030;
    }
  }

  &__options {
    position: absolute;
    display: block;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    z-index: 2;
    border-radius: 0 0 3px 3px;
    box-shadow:
      0 5px 5px rgba(0, 0, 0, 0.08),
      0 7px 7px rgba(0, 0, 0, 0.04),
      0 3px 1px -2px rgba(0, 0, 0, 0.12);
    transition: all 0.5s;
  }

  &__option {
    position: relative;
    display: block;
    padding: 0 22px 0 22px;
    color: #303030;
    line-height: 36px;
    cursor: pointer;
    transition: all 0.5s;

    &:hover {
      cursor: pointer;
      background-color: #fafafa;
    }

    &.selected {
      color: #ffffff;
      background-color: #fafafa;
    }
  }
}

.arrow {
  position: relative;
  height: 15px;
  width: 15px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-top: 5px solid #7a7a7a;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
    border-bottom: 0 solid #7a7a7a;
    overflow: hidden;
    transition: 0.3s ease;
  }
}
</style>
